import React from 'react';
import { Circle } from 'lucide-react';
export function ActivityFeed() {
  const activities = [{
    id: 1,
    title: 'Label Approved',
    description: 'WIN-CAB-2020 label approved by TTB',
    time: '5m ago',
    status: 'success'
  }, {
    id: 2,
    title: 'Review Required',
    description: 'New vintage label needs review',
    time: '1h ago',
    status: 'warning'
  }, {
    id: 3,
    title: 'Compliance Alert',
    description: 'WIN-PIN-2019 missing required AVA statement',
    time: '2h ago',
    status: 'error'
  }];
  return <div className="bg-white border rounded-lg p-6" data-id="element-2">
      <h2 className="text-lg font-semibold mb-4" data-id="element-3">Recent Activity</h2>
      <div className="space-y-4" data-id="element-4">
        {activities.map(activity => <div key={activity.id} className="flex items-start gap-3" data-id="element-5">
            <Circle className={`w-2 h-2 mt-2 ${activity.status === 'success' ? 'text-green-500' : activity.status === 'warning' ? 'text-yellow-500' : 'text-red-500'}`} data-id="element-6" />
            <div data-id="element-7">
              <p className="font-medium text-sm" data-id="element-8">{activity.title}</p>
              <p className="text-sm text-gray-600" data-id="element-9">{activity.description}</p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-10">{activity.time}</p>
            </div>
          </div>)}
      </div>
    </div>;
}